import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    UpdateRelatedAccount as UpdateRelatedAccountMutation,
    UpdateRelatedAccountVariables,
    AccountUpdateInput,
} from 'nutshell-graphql-types';

import ACCOUNT_FOR_CORE_ENTITY_FRAGMENT from '../../../../../../core-entity/graphql/fragments/account-for-core-entity-fragment.graphql';

import UPDATE_RELATED_ACCOUNT from '../mutations/update-related-account.graphql';

export const useUpdateRelatedAccount = (): {
    updateRelatedAccount: (input: AccountUpdateInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [updateRelatedAccount, {loading, error}] = useMutation<
        UpdateRelatedAccountMutation,
        UpdateRelatedAccountVariables
    >(UPDATE_RELATED_ACCOUNT);

    return {
        updateRelatedAccount: (input: AccountUpdateInput) =>
            updateRelatedAccount({
                variables: {input},
                update: (proxy, mutationResults) => {
                    const updatedAccount = mutationResults?.data?.accountUpdate?.account;

                    if (!updatedAccount) {
                        return;
                    }

                    proxy.writeFragment({
                        id: updatedAccount.id,
                        fragment: ACCOUNT_FOR_CORE_ENTITY_FRAGMENT,
                        fragmentName: 'AccountForCoreEntityFragment',
                        data: {
                            ...updatedAccount,
                        },
                    });
                },
            }),
        isLoading: loading,
        // @ts-expect-error
        error: error && safelyGetGraphQLErrorMessage(error),
    };
};
